import {usePopUpStore} from 'contexts/StoreContext';
import {NotificationType} from 'stores/PopUpStore';
import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Image, Text, TouchableOpacity, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';
import {observable} from 'mobx';
import {observer} from 'mobx-react';

export interface NavigationPopUpProps {}

const NavigationPopUp = observer((props: NavigationPopUpProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const popUpStore = usePopUpStore();

  if (!popUpStore.notification) {
    return <></>;
  }

  const statusText = strings.popup[popUpStore.notification.type];
  const statusImage = theme.images[popUpStore.notification.type];

  return (
    <View style={styles.container}>
      <View style={styles.popupContainer}>
        <View style={styles.popupTopView}>
          <Image source={statusImage} style={styles.statusImage} />
          <Text style={styles.statusText}>{statusText}</Text>
          <TouchableOpacity onPress={popUpStore.close}>
            <Image source={theme.images.cross} style={styles.crossImage} />
          </TouchableOpacity>
        </View>
        <Text style={styles.text}>{popUpStore.notification?.text}</Text>
      </View>
    </View>
  );
});

export default NavigationPopUp;
